<template>
  <div class="auth-page-wrapper" :class="{ 'password-reset': singleColumn }">
    <div class="auth-container" :class="{ 'single-column': singleColumn }">
      <!-- Left/Main Column: Form -->
      <div class="auth-form-column">
        <slot name="form" />
      </div>

      <!-- Right Column: Illustration -->
      <div v-if="showIllustration && !singleColumn" class="auth-illustration-column">
        <AuthIllustration />
      </div>
    </div>
  </div>
</template>

<script>
import AuthIllustration from './AuthIllustration';

export default {
  name: 'AuthLayout',
  components: {
    AuthIllustration
  },
  props: {
    showIllustration: {
      type: Boolean,
      default: true
    },
    singleColumn: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/_mixins.scss';
@import '@/styles/_auth-tokens.scss';

.auth-page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--dark-onboarding-background);
  padding: $auth-gap-md;

  @include mobile {
    padding: 0;
    align-items: flex-start;
  }

  &.password-reset {
    background: var(--dark-password-reset-background);
  }
}

.auth-container {
  display: flex;
  align-items: stretch;
  gap: $auth-container-gap;
  width: 100%;
  min-height: calc(100vh - #{$auth-gap-md * 2});
  background: var(--dark-card-background);
  border-radius: $auth-border-radius-card;

  @include mobile {
    flex-direction: column;
    border-radius: 0;
    padding: $auth-gap-md $auth-gap-sm;
    min-height: 100vh;
  }

  &.single-column {
    justify-content: center;
    background: transparent;

    .auth-form-column {
      max-width: $auth-form-max-width;
      background: transparent;
    }
  }
}

.auth-form-column {
  display: flex;
  max-width: $auth-form-max-width;
  padding: 0 $auth-padding-horizontal;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  background: var(--dark-card-background);
  border-radius: $auth-border-radius-card;

  @include mobile {
    width: 100%;
    padding: $auth-gap-lg 0;
  }
}

.auth-illustration-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
  background: var(--auth-background);
  border-radius: $auth-border-radius-card;
  overflow: hidden;
  position: relative;

  @include mobile {
    display: none;
  }
}
</style>
